// SmashUp.io — client game configuration (mirrors backend progression math)

export const WORLD = { w: 4200, h: 4200 };
export const MATCH_DURATION = 210; // seconds (3.5 min)
export const COMBO_DECAY = 3.6; // seconds
export const NUM_BOTS = 11;

// ---- Vehicle evolution tiers ----
export const VEHICLES = [
  { id: 0, name: "Small Buggy",               unlockLevel: 1,  radius: 20, maxSpeed: 5.4, accel: 0.16, turn: 0.055, maxHealth: 100, smashPower: 1,  boostMax: 100, wheels: 4, body: "#FF9500" },
  { id: 1, name: "Pickup Truck",              unlockLevel: 3,  radius: 26, maxSpeed: 5.6, accel: 0.15, turn: 0.048, maxHealth: 160, smashPower: 2,  boostMax: 110, wheels: 4, body: "#FFB020" },
  { id: 2, name: "Heavy Truck",               unlockLevel: 5,  radius: 33, maxSpeed: 5.5, accel: 0.13, turn: 0.040, maxHealth: 240, smashPower: 3,  boostMax: 120, wheels: 6, body: "#F97316" },
  { id: 3, name: "Bulldozer",                 unlockLevel: 8,  radius: 41, maxSpeed: 5.2, accel: 0.12, turn: 0.034, maxHealth: 340, smashPower: 5,  boostMax: 130, wheels: 4, body: "#FFCC00" },
  { id: 4, name: "Armored Vehicle",           unlockLevel: 11, radius: 50, maxSpeed: 5.6, accel: 0.13, turn: 0.032, maxHealth: 460, smashPower: 7,  boostMax: 150, wheels: 6, body: "#22D3EE" },
  { id: 5, name: "Heavy Destruction Machine", unlockLevel: 15, radius: 60, maxSpeed: 5.9, accel: 0.14, turn: 0.030, maxHealth: 620, smashPower: 10, boostMax: 170, wheels: 8, body: "#A855F7" },
  { id: 6, name: "Ultimate Smash Machine",    unlockLevel: 20, radius: 74, maxSpeed: 6.4, accel: 0.16, turn: 0.030, maxHealth: 850, smashPower: 15, boostMax: 200, wheels: 8, body: "#FF2A55" },
  { id: 7, name: "Monster Rig",               unlockLevel: 24, radius: 88, maxSpeed: 6.6, accel: 0.16, turn: 0.028, maxHealth: 1100, smashPower: 20, boostMax: 220, wheels: 10, body: "#FB923C" },
  { id: 8, name: "Apocalypse Tank",           unlockLevel: 28, radius: 104,maxSpeed: 7.0, accel: 0.17, turn: 0.026, maxHealth: 1500, smashPower: 28, boostMax: 260, wheels: 12, body: "#22C55E" },
];

export function vehicleForLevel(level) {
  let v = VEHICLES[0];
  for (const t of VEHICLES) if (level >= t.unlockLevel) v = t;
  return v;
}

// ---- In-match XP curve (mirror of backend) ----
export function xpForLevel(level) {
  if (level <= 1) return 0;
  return Math.floor(60 * (level - 1) + 8 * Math.pow(level - 1, 2.15));
}

// ---- Destructible object catalog ----
export const OBJECTS = {
  // small
  box:        { cat: "small",  hp: 10,  tough: 1,  radius: 16, score: 45,  xp: 4,  coins: 1, color: "#C08457", debris: "#8a5c3a", material: "wood" },
  barrel:     { cat: "small",  hp: 14,  tough: 1,  radius: 15, score: 55,  xp: 5,  coins: 1, color: "#E63946", debris: "#a02830", material: "metal", explosive: true, blast: 95 },
  sign:       { cat: "small",  hp: 8,   tough: 1,  radius: 14, score: 40,  xp: 4,  coins: 1, color: "#2A9D8F", debris: "#1d6b62", material: "metal" },
  cone:       { cat: "small",  hp: 6,   tough: 1,  radius: 12, score: 30,  xp: 3,  coins: 0, color: "#FF6B35", debris: "#c24d20", material: "plastic" },
  trash:      { cat: "small",  hp: 12,  tough: 1,  radius: 17, score: 50,  xp: 5,  coins: 1, color: "#4CAF50", debris: "#357a38", material: "plastic" },
  hydrant:    { cat: "small",  hp: 16,  tough: 1,  radius: 13, score: 60,  xp: 5,  coins: 1, color: "#EF476F", debris: "#b0324f", material: "metal" },
  // medium
  car:        { cat: "medium", hp: 45,  tough: 2,  radius: 30, score: 220, xp: 16, coins: 4, color: "#457B9D", debris: "#2c556e", material: "glass", explosive: true, blast: 120 },
  van:        { cat: "medium", hp: 60,  tough: 2,  radius: 36, score: 280, xp: 20, coins: 5, color: "#8D99AE", debris: "#5c6577", material: "metal", explosive: true, blast: 130 },
  barrier:    { cat: "medium", hp: 70,  tough: 3,  radius: 34, score: 240, xp: 18, coins: 4, color: "#F4A261", debris: "#c07836", material: "concrete" },
  container:  { cat: "medium", hp: 110, tough: 3,  radius: 46, score: 420, xp: 30, coins: 8, color: "#E76F51", debris: "#a84a34", material: "metal" },
  // large
  truck:      { cat: "large",  hp: 200, tough: 5,  radius: 58, score: 800, xp: 55, coins: 16, color: "#264653", debris: "#152a32", material: "metal", explosive: true, blast: 170 },
  crane:      { cat: "large",  hp: 320, tough: 7,  radius: 70, score: 1300,xp: 90, coins: 26, color: "#FFB703", debris: "#c88a00", material: "metal", explosive: true, blast: 200 },
  building:   { cat: "large",  hp: 500, tough: 10, radius: 90, score: 2200,xp: 150,coins: 45, color: "#6C757D", debris: "#454b50", material: "concrete", building: true, blast: 240, explosive: true },
};
export const OBJECT_KEYS = Object.keys(OBJECTS);

// Material -> debris chunk colours (for juicier, type-specific destruction).
export const DEBRIS = {
  wood: ["#8a5c3a", "#b07a4e", "#5f3d24"],
  metal: ["#9aa3b0", "#c7ccd6", "#5b6270"],
  plastic: ["#e0e0e0", "#c24d20", "#357a38"],
  concrete: ["#9ea3a8", "#c2c7cc", "#6b7075"],
  glass: ["#a8d8e8", "#d6f2ff", "#7fb8cc"],
};

// ---- Combo tiers ----
export function comboMult(count) {
  if (count >= 25) return 10;
  if (count >= 15) return 8;
  if (count >= 10) return 5;
  if (count >= 5) return 3;
  if (count >= 2) return 2;
  return 1;
}

// ---- Cosmetic themes ----
export const THEME_COLORS = {
  classic: "#FF9500", fire: "#FF3B30", neon: "#00E5FF",
  chrome: "#C0C6D0", desert: "#D9A05B", cyber: "#9D4EDD",
  galaxy: "#7C3AED", magma: "#F43F5E", toxic: "#84CC16", champion: "#FFD700",
};

export const BOT_NAMES = ["Reaper","Titan","Crusher","Havoc","Vortex","Rampage","Blitz","Onyx","Fury","Mauler","Diesel","Nitro","Wrecker","Goliath","Rex","Venom","Bandit","Cyclone","Juggernaut","Ripsaw"];

export const BOOST = { drain: 42, regen: 16, speedMult: 1.85, powerMult: 1.6 };

// Cosmetic id -> color (mirrors backend catalog) for in-match rendering.
export const COSMETIC_COLORS = {
  skin_classic: "#FF9500", skin_fire: "#FF3B30", skin_neon: "#00E5FF", skin_chrome: "#C0C6D0", skin_desert: "#D9A05B", skin_cyber: "#9D4EDD",
  trail_flame: "#FF6A00", trail_neon: "#00E5FF", trail_rainbow: "#FF2A55",
  paint_neon: "#39FF14", paint_gold: "#FFD700",
  wheel_stock: "#1A1A1A", wheel_offroad: "#3A2E1F", wheel_chrome: "#D6DCE6", wheel_neon: "#00E5FF", wheel_gold: "#FFD700",
  smash_classic: "#C9C9C9", smash_fire: "#FF6A00", smash_electric: "#00E5FF", smash_gold: "#FFD700", smash_void: "#9D4EDD",
  boost_blue: "#00E5FF", boost_flame: "#FF3B30", boost_plasma: "#9D4EDD", boost_rainbow: "#39FF14",
  trail_ghost: "#E0E7FF", boost_gold: "#FFD700",
  skin_galaxy: "#7C3AED", skin_magma: "#F43F5E", skin_toxic: "#84CC16",
  trail_gold: "#FFD700", wheel_spike: "#EF4444", smash_rainbow: "#22D3EE", boost_ion: "#38BDF8",
  skin_champion: "#FFD700",
  skin_shadow: "#4B5563", skin_ice: "#7DD3FC", wheel_turbo: "#F59E0B",
  trail_ember: "#FB7185", smash_frost: "#A855F7",
  skin_venom: "#4ADE80", skin_inferno: "#EF4444", skin_arctic: "#38BDF8", skin_obsidian: "#1F2937",
  wheel_phantom: "#A78BFA", wheel_inferno: "#F97316",
  trail_toxic: "#84CC16", trail_frost: "#7DD3FC",
  smash_shock: "#22D3EE", smash_magma: "#F97316",
  boost_toxic: "#A3E635", boost_frost: "#7DD3FC",
  paint_royal: "#8B5CF6", paint_inferno: "#EF4444",
};
